import { defineMessages } from 'react-intl';

export const routes = defineMessages({
  homePageRoute: {
    id: 'src.constants.routing.homePageRoute',
    defaultMessage: '/:language({languageParamRegex})?',
  },
  popRoute: {
    id: 'src.constants.routing.popRoute',
    defaultMessage: '/:language({languageParamRegex})?/cadeaubonnen/:page(\\d+)?/',
  },
  pdpRoute: {
    id: 'src.constants.routing.pdpRoute',
    defaultMessage: '/:language({languageParamRegex})?/cadeaubonnen/:product/',
  },
  basketPageRoute: {
    id: 'src.constants.routing.basketPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/winkelmandje/',
  },
  checkoutPageRoute: {
    id: 'src.constants.routing.checkoutPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/bestellen/',
  },
  confirmationPageRoute: {
    id: 'src.constants.routing.confirmationPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/bestellen/:uuid/',
  },
  confirmationPageRouteV2: {
    id: 'src.constants.routing.confirmationPageRouteV2',
    defaultMessage: '/:language({languageParamRegex})?/bestellen/gelukt/',
  },
  redeemPageRoute: {
    id: 'src.constants.routing.redeemPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/saldocheck/',
  },
  redeemShopPageRoute: {
    id: 'src.constants.routing.redeemShopPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/saldocheck/inwisselen/:page(\\d+)?/',
  },
  redeemB2BShopPageRoute: {
    id: 'src.constants.routing.redeemB2BShopPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/saldocheck/inwisselen/:pageId/:page(\\d+)?/',
  },
  redeemGiftcardPageRoute: {
    id: 'src.constants.routing.redeemGiftcardPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/saldocheck/info/:pageId/',
  },
  redeemnCheckoutPageRoute: {
    id: 'src.constants.routing.redeemnCheckoutPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/saldocheck/checkout/',
  },
  givingMomentsPopRoute: {
    id: 'src.constants.routing.givingMomentsPopRoute',
    defaultMessage: '/:language({languageParamRegex})?/geefmomenten/',
  },
  givingMomentsPdpRoute: {
    id: 'src.constants.routing.givingMomentsPdpRoute',
    defaultMessage: '/:language({languageParamRegex})?/geefmomenten/:product/',
  },
  businessPageRoute: {
    id: 'src.constants.routing.businessPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/zakelijk/:product?/',
  },
  termsAndConditionsRoute: {
    id: 'src.constants.routing.termsAndConditionsRoute',
    defaultMessage: '/:language({languageParamRegex})?/algemene-voorwaarden/',
  },
  privacyPageRoute: {
    id: 'src.constants.routing.privacy',
    defaultMessage: '/:language({languageParamRegex})?/privacy/',
  },
  helpdeskRoute: {
    id: 'src.constants.routing.helpdeskRoute',
    defaultMessage: '/:language({languageParamRegex})?/helpdesk/',
  },
  contactPageRoute: {
    id: 'src.constants.routing.contactPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/klantenservice/contact/',
  },
  blogPopRoute: {
    id: 'src.constants.routing.blogPopRoute',
    defaultMessage: '/:language({languageParamRegex})?/blog/',
  },
  blogPdpRoute: {
    id: 'src.constants.routing.blogPdpRoute',
    defaultMessage: '/:language({languageParamRegex})?/blog/:path/',
  },
  cookiesPageRoute: {
    id: 'src.constants.routing.cookiesPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/cookieverklaring/',
  },
  allCategoriesPageRoute: {
    id: 'src.constants.routing.allCategoriesPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/categorie/alle-cadeaubonnen/',
  },
  categoryPageRoute: {
    id: 'src.constants.routing.categoryPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/categorie/:url/:page(\\d+)?/',
  },
  doublerConfirmationPageRoute: {
    id: 'src.constants.routing.doublerConfirmationPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/verdubbelaar/bedankt/:product?/',
  },
  doublerHomePageRoute: {
    id: 'src.constants.routing.doublerHomePageRoute',
    defaultMessage: '/:language({languageParamRegex})?/verdubbelaar/',
  },
  accountIdentifyPageRoute: {
    id: 'src.constants.routing.accountIdentifyPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/',
  },
  loginPageRoute: {
    id: 'src.constants.routing.loginPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/login/',
  },
  accountRegisterPageRoute: {
    id: 'src.constants.routing.accountRegisterPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/registreren/',
  },
  accountRegisterSuccessPageRoute: {
    id: 'src.constants.routing.accountRegisterSuccessPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/registreren/success/',
  },
  forgotPasswordPageRoute: {
    id: 'src.constants.routing.forgotPasswordPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/wachtwoord-vergeten/',
  },
  forgotPasswordConfirmPageRoute: {
    id: 'src.constants.routing.forgotPasswordConfirmPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/wachtwoord-vergeten/success/',
  },
  newPasswordPageRoute: {
    id: 'src.constants.routing.newPasswordPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/nieuw-wachtwoord/',
  },
  newPasswordConfirmationPageRoute: {
    id: 'src.constants.routing.newPasswordConfirmationPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/nieuw-wachtwoord/succes/',
  },
  accountOverviewPageRoute: {
    id: 'src.constants.routing.accountOverviewPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/overzicht/',
  },
  accountOrdersPageRoute: {
    id: 'src.constants.routing.accountOrdersPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/bestellingen/',
  },
  accountAddressBookPageRoute: {
    id: 'src.constants.routing.accountAddressBookPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/adresboek/',
  },
  accountDataPageRoute: {
    id: 'src.constants.routing.accountDataPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/account/gegevens/',
  },
  locationsOverviewPageRoute: {
    id: 'src.constants.routing.locationsOverviewPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/cadeaubonnen/:product/locaties/',
  },
  locationDetailsPageRoute: {
    id: 'src.constants.routing.locationDetailsPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/cadeaubonnen/:product/locaties/:location/',
  },
  activationPageRoute: {
    id: 'src.constants.routing.activationPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/activeren/',
  },
  activationConfirmationPageRoute: {
    id: 'src.constants.routing.activationConfirmationPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/activeren/gelukt/',
  },
  notFoundPageRoute: {
    id: 'src.constants.routing.notFoundPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/404/',
  },
  reorderPageRoute: {
    id: 'src.constants.routing.reorderPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/nabestellen/',
  },
  landingPageRoute: {
    id: 'src.constants.routing.landingPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/:path/',
  },
  choiceGiftcardRoute: {
    id: 'src.constants.routing.choiceGiftcardRoute',
    defaultMessage: '/:language({languageParamRegex})?/cadeaubonnen/cadeaubonnl-keuze-cadeaukaart/',
  },
  adyenProcessingPageRoute: {
    id: 'src.constants.routing.adyenProcessingPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/bestellen/betaling-verwerken/',
  },
  deliveryPageRoute: {
    id: 'src.constants.routing.deliveryPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/delivery/',
  },
  cancelationPolicyPageRoute: {
    id: 'src.constants.routing.cancelationPolicyPageRoute',
    defaultMessage: '/:language({languageParamRegex})?/cancelation-policy/',
  },
});
